export function getSavedRequestFeedback(result, fallback) {
  const savedMessage = result?.message || fallback;
  const notification = result?.notification;
  return {
    type: notification?.status === 'failed' ? 'warning' : 'success',
    message: [savedMessage, notification
      ? notification.message
      : 'Pulsa TERMINAR Y ENVIAR para avisar a los administradores.'].filter(Boolean).join(' '),
  };
}
